export default {
  instaTaskMainWrapper: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
    width: (theme) => `calc(100% - ${theme.customValues.taskSidebarWidth})`,
    borderLeft: (theme) => `1px solid ${theme.palette.grays.gray200}`,
    '@media (max-width: 760px)': {
      width: '100%',
      order: 1,
      flex: 'unset',
      minHeight: 'auto',
    },
  },
  instaTaskContentWrapper: {
    width: '100%',
    flex: 1,
    minHeight: 0,
    padding: '20px',
    overflow: 'auto',
    boxSizing: 'border-box',

    '@media (max-width: 760px)': {
      flex: 'unset',
      minHeight: 'auto',
      overflow: 'visible',
    },
  },
};
